module.exports = __webpack_public_path__ + "static/media/lucky-wheel-img-7.a711d652.png";